module.exports = __webpack_public_path__ + "img/img.ccefb8be.png";